import { bl_ppl_ap_inbox_doc_hdr_RowClass } from '../../../dbschema/bl_ppl_ap_inbox_doc_hdr.model';
import { BaseContainerModel } from '../../base-container.model';

export class PeppolAPInboxDocHdrContainerModel extends BaseContainerModel {
    bl_ppl_ap_inbox_doc_hdr: bl_ppl_ap_inbox_doc_hdr_RowClass = new bl_ppl_ap_inbox_doc_hdr_RowClass();
}